import * as BlackburnComponents from 'blackburn-components';

export default {
  install(app) {
    // Iterate over each component and register it globally
    Object.entries(BlackburnComponents).forEach(([componentName, component]) => {
      app.component(componentName, component);
    });
  },
};
